import "./App.css";
import { observer } from "mobx-react-lite";
import CustomerTheme from "./themes/customer/CustomerTheme";
import AdminTheme from "./themes/admin/AdminTheme";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
type AppProps = {
  pca: IPublicClientApplication;
};
function App({ pca }: AppProps) {
  if (process.env.REACT_APP_THEME === "customer") {
    return (
      <>
        <MsalProvider instance={pca}>
          <CustomerTheme />
        </MsalProvider>
      </>
    );
  } else {
    return (
      <>
        <MsalProvider instance={pca}>
          <AdminTheme />
        </MsalProvider>
      </>
    );
  }
}

export default observer(App);
